import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoadResolver from "components/LoadResolver";
import { ResolutionForm } from "forms/Resolution";
import { ResolutionsTable } from "../ResolutionsTable/ResolutionsTable";
import { getRequiredResolution } from "services/apiMiddleware";
import { toast } from "../Toast/Toast";
import { getNativeResolutions, getRequiredResolutions } from "store/selectors";
import { Divider } from "semantic-ui-react";

export const DigitalSizeEditor = ({ dispatch, t }) => {
  const nativeResolutionsState = useSelector(getNativeResolutions);
  const requiredResolutionsState = useSelector(getRequiredResolutions);
  const [updatingRes, setUpdatingRes] = useState(false);
  const [updateResData, setUpdateResData] = useState(null);

  useEffect(() => {
    dispatch.nativeResolutions.load();
    dispatch.requiredResolutions.load();
  }, []);

  const selectorError = () => {
    const nativeError = nativeResolutionsState.error;
    const requiredError = requiredResolutionsState.error;

    if (nativeError) return nativeError;
    else if (requiredError) return requiredError;
    else return undefined;
  };

  const handleUpdateRes = (nativeRes) => {
    setUpdateResData(nativeRes);
    setUpdatingRes(true);
  };

  const handleUpdateActivation = async (nativeRes) => {
    // If native resolution is currently active, we are deactivating it
    const isActivating = !nativeRes.active;
    try {
      await dispatch.nativeResolutions.update({ id: nativeRes.id, active: isActivating });

      toast(
        undefined,
        isActivating ? t("digital_size_activation_success") : t("digital_size_deactivation_success")
      );
    } catch (error) {
      console.error(error);
      toast(
        "error",
        isActivating ? t("digital_size_activation_failure") : t("digital_size_deactivation_failure")
      );
    }
  };

  const handleDeleteRes = async (nativeRes) => {
    try {
      await dispatch.nativeResolutions.delete(nativeRes);

      // Delete required resolution if it is now not used by any native resolution
      const { data } = await getRequiredResolution(nativeRes.requiredResolutionID);
      if (data && data.nativeResolutions.items.length === 0) {
        await dispatch.requiredResolutions.delete(data);
      }
      toast(undefined, t("digital_size_delete_success"));
    } catch (error) {
      console.error(error);
      toast("error", t("digital_size_delete_failure"));
    }
  };

  return (
    <LoadResolver
      isLoading={nativeResolutionsState.isLoading || requiredResolutionsState.isLoading}
      error={selectorError()}
    >
      <div className="page-container">
        <h2>{t("digital_sizes")}</h2>
        <ResolutionForm
          requiredResolutions={requiredResolutionsState.items}
          nativeResolutions={nativeResolutionsState.items}
          dispatch={dispatch}
          t={t}
        />
        <br />
        {updatingRes && (
          <div>
            <ResolutionForm
              requiredResolutions={requiredResolutionsState.items}
              nativeResolutions={nativeResolutionsState.items}
              resolutionToUpdate={updateResData}
              setUpdatingRes={setUpdatingRes}
              dispatch={dispatch}
              t={t}
            />
            <br />
          </div>
        )}
        <Divider />
        <ResolutionsTable
          items={nativeResolutionsState.items}
          handleUpdate={handleUpdateRes}
          updatingRes={updatingRes}
          handleDelete={handleDeleteRes}
          handleUpdateActivation={handleUpdateActivation}
          t={t}
        />
      </div>
    </LoadResolver>
  );
};
